export function careerModal() {
	const careerApplyTitle = $('.recruitment-detail-page h1').text();
	$('#modal-apply .career-dt-title').text(careerApplyTitle);
	$('#modal-apply .form-apply-title input').val(careerApplyTitle);
}
